import snakeCase from 'lodash/snakeCase';

// Feature flags naming convention: https://goatapp.atlassian.net/wiki/spaces/FRON/pages/118751233/Using+Feature+Flags
export enum FeatureFlags {
  // Permanent Flags
  // ---------------------------------------------------------------------------
  WEB_ENABLE_AFFIRM = 'webEnableAffirm',
  WEB_ENABLE_AFTERPAY = 'webEnableAfterpay',
  WEB_ENABLE_ALIPAY = 'webEnableAlipay',
  WEB_ENABLE_AUCTIONS = 'webEnableAuctions',
  WEB_ENABLE_BLACK_FRIDAY_BLACKOUT = 'webEnableBlackFridayBlackout',
  WEB_ENABLE_BLACK_FRIDAY_IN_NAV = 'webEnableBlackFridayInNav',
  WEB_ENABLE_BRAND_HALF_TAB = 'webEnableBrandHalfTab',
  WEB_ENABLE_CHECKOUT_GIFT_CARDS = 'webEnableCheckoutGiftCards',
  WEB_ENABLE_CHECKOUT_GIFT_CARDS_ALLOW_GUEST_PURCHASE = 'webEnableCheckoutGiftCardsAllowGuestPurchase',
  WEB_ENABLE_CHECKOUT_GIFT_CARDS_ALLOW_GUEST_REDEMPTION = 'webEnableCheckoutGiftCardsAllowGuestRedemption',
  WEB_ENABLE_CHECKOUT_OFFERS = 'webEnableCheckoutOffers',
  WEB_ENABLE_CHECKOUT_PURCHASE_GIFT_CARDS = 'webEnableCheckoutPurchaseGiftCards',
  WEB_CIRCUMVENT_DARWIN = 'webCircumventDarwin',
  WEB_ENABLE_COHORT_ASSIGNMENT = 'webEnableCohortAssignment',
  WEB_ENABLE_DEFAULT_HOME_TAB_BRAND = 'webEnableDefaultHomeTabBrand',
  WEB_ENABLE_DEFAULT_HOME_TAB_DISCOVER = 'webEnableDefaultHomeTabDiscover',
  WEB_ENABLE_GIFT_CARDS_REQUIRE_EMAIL_ENTRY = 'webEnableGiftCardsRequireEmailEntry',
  WEB_ENABLE_GIROPAY = 'webEnableGiropay',
  WEB_ENABLE_GOAT_BANNER = 'webEnableGoatBanner',
  WEB_ENABLE_GOOGLE_RECAPTCHA = 'webEnableGoogleRecaptcha',
  WEB_ENABLE_GUEST_CHECKOUT = 'webEnableGuestCheckout',
  WEB_ENABLE_HOMEPAGE_BRAND_TAB = 'webEnableHomepageBrandTab',
  WEB_ENABLE_HOW_TO_PLAY_MOBILE_REDIRECT = 'webEnableHowToPlayMobileRedirect',
  WEB_ENABLE_IMPACT = 'webEnableImpact',
  WEB_ENABLE_KLARNA = 'webEnableKlarna',
  WEB_ENABLE_LATEST_SEARCHES = 'webEnableLatestSearches',
  WEB_ENABLE_MANIFESTO_COLLECTION = 'webEnableManifestoCollection',
  WEB_ENABLE_MPARTICLE = 'webEnableMparticle',
  WEB_ENABLE_ON_SALE = 'webEnableOnSale',
  WEB_ENABLE_ONE_TRUST = 'webEnableOneTrust',
  WEB_ENABLE_PAGE_PERFORMANCE_ANALYTICS = 'webEnablePagePerformanceAnalytics',
  WEB_ENABLE_PAYPAL = 'webEnablePaypal',
  WEB_ENABLE_POST_BLACK_FRIDAY = 'webEnablePostBlackFriday',
  WEB_ENABLE_PRE_BLACK_FRIDAY = 'webEnablePreBlackFriday',
  WEB_ENABLE_RECENT_SEARCHES = 'webEnableRecentSearches',
  WEB_ENABLE_SEARCH_COLLECTION_SUGGESTIONS = 'webEnableSearchCollectionSuggestions',
  WEB_ENABLE_SNAPCHAT = 'webEnableSnapchat',
  WEB_ENABLE_SUGGESTED_SEARCHES = 'webEnableSuggestedSearches',
  WEB_ENABLE_TIKTOK = 'webEnableTiktok',
  WEB_ENABLE_TOGGLE_NEXT_PREV_BRAND_FEED = 'webEnableToggleNextPrevBrandFeed',
  WEB_ENABLE_TOGGLE_NEXT_PREV_MANIFESTO = 'webEnableToggleNextPrevManifesto',
  WEB_ENABLE_LIGHT_NEXT_PREV_BUTTONS_BRAND_FEED = 'webEnableLightNextPrevButtonsBrandFeed',

  // Temporary Flags
  // ---------------------------------------------------------------------------
  TEMP_SETTLE_OFFERS_IN_USD = 'tempSettleOffersInUsd',
  TEMP_WEB_ACTIVITY_MODAL = 'tempWebActivityModal',
  TEMP_WEB_DISABLE_REFETCH_FOR_UNAVAILABLE_REGION = 'tempWebDisableRefetchForUnavailableRegion',
  TEMP_WEB_ENABLE_ATO_MITIGATION = 'tempWebEnableAtoMitigation',
  TEMP_WEB_ENABLE_BLACK_FRIDAY_TRIVIA = 'tempWebEnableBlackFridayTrivia',
  TEMP_WEB_ENABLE_BRAND_STORY = 'tempWebEnableBrandStory', // TODO: clean up
  TEMP_WEB_ENABLE_COLLECTION_IN_COLLECTION = 'tempWebEnableCollectionInCollection',
  TEMP_WEB_ENABLE_COMMUNITY_EXPLORATION = 'tempWebEnableCommunityExploration',
  TEMP_WEB_ENABLE_CONSUMER_SEGMENT_ACCESS_CALL = 'tempWebEnableConsumerSegmentAccessCall',
  TEMP_WEB_ENABLE_EDITORIAL_SPACE = 'tempWebEnableEditorialSpace',
  TEMP_WEB_ENABLE_FIT_FEEDBACK_CM = 'tempWebEnableFitFeedbackCm',
  TEMP_WEB_ENABLE_GIFT_CARD_REDEMPTION_TEXT_ANDROID = 'tempWebEnableGiftCardRedemptionTextAndroid',
  TEMP_WEB_ENABLE_GIFT_CARD_REDEMPTION_TEXT_IOS = 'tempWebEnableGiftCardRedemptionTextIos',
  TEMP_WEB_ENABLE_GIFT_CARDS_SUGGESTED_SEARCH = 'tempWebEnableGiftCardsSuggestedSearch',
  TEMP_WEB_ENABLE_GUEST_CHECKOUT_PRICE_BREAKDOWN = 'tempWebEnableGuestCheckoutPriceBreakdown',
  TEMP_WEB_ENABLE_HONEST_STATUS_CODE_PDP = 'tempWebEnableHonestStatusCodePdp',
  TEMP_WEB_ENABLE_LANGUAGE_SELECTION = 'tempWebEnableLanguageSelection',
  TEMP_WEB_ENABLE_MANIFESTO = 'tempWebEnableManifesto', // TODO: clean up
  TEMP_WEB_ENABLE_OFFER_MODAL_UPDATES = 'tempWebEnableOfferModalUpdates',
  TEMP_WEB_ENABLE_OFFERS_LOGIN_TEST_2024 = 'tempWebEnableOffersLoginTest2024',
  TEMP_WEB_ENABLE_PAGINATION_SORT = 'tempWebEnablePaginationSort',
  TEMP_WEB_ENABLE_PAYPAL_CANADA = 'tempWebEnablePaypalCanada',
  TEMP_WEB_ENABLE_PDP_CUSTOM_FEATURED_IN_LINKS = 'tempWebEnablePdpCustomFeaturedInLinks',
  TEMP_WEB_ENABLE_PDP_IMAGE_ALT_TAG = 'tempWebEnablePdpImageAltTag',
  TEMP_WEB_ENABLE_PRICING_LIST_UPDATE = 'tempWebEnablePricingListUpdate',
  TEMP_WEB_ENABLE_PRODUCT_GROUP_SCHEMA = 'tempWebEnableProductGroupSchema',
  TEMP_WEB_ENABLE_PROFILE_AND_ALERTS_PDP_LINK_FLOW = 'tempWebEnableProfileAndAlertsPdpLinkFlow',
  TEMP_WEB_ENABLE_PSG_COLLECTION_GRID = 'tempWebEnablePsgCollectionGrid', // TODO: clean up
  TEMP_WEB_ENABLE_PSG_PREV_NEXT_BUTTONS = 'tempWebEnablePsgPrevNextButtons', // TODO: clean up
  TEMP_WEB_ENABLE_RESERVE_FLOW = 'tempWebEnableReserveFlow',
  TEMP_WEB_ENABLE_SEARCH_MICROFRONTEND = 'tempWebEnableSearchMicrofrontend',
  TEMP_WEB_ENABLE_SORT_CONSUMER_SEARCH_FEATURED_IN = 'tempWebEnableSortConsumerSearchFeaturedIn',
  TEMP_WEB_ENABLE_SPIKE_MITIGATION = 'tempWebEnableSpikeMitigation', // TODO: clean up
  TEMP_WEB_ENABLE_TRIVIA_TEST = 'tempWebEnableTriviaTest',
  TEMP_WEB_ENABLE_UPDATED_FIT_MODAL = 'tempWebEnableUpdatedFitModal',
  TEMP_WEB_ENABLE_USER_SPACES = 'tempWebEnableUserSpaces', // TODO: clean up - FF not in prod
  TEMP_WEB_ENABLE_VIEW_STRUCTURED_DATA = 'tempWebEnableViewStructuredData',
  TEMP_WEB_ENABLE_WANTS_PURCHASE_FLOW_DARWIN_TEST = 'tempWebEnableWantsPurchaseFlowDarwinTest',
  TEMP_WEB_FORCE_SHOW_SHIPPING_TAB = 'tempWebForceShowShippingTab',
  TEMP_WEB_NEW_PERFORMANCE_SPACE = 'tempWebNewPerformanceSpace',
  TEMP_WEB_ENABLE_CHECKOUT_PLATFORM_ROLLOUT = 'tempWebEnableCheckoutPlatformRollout',
  TEMP_WEB_ENABLE_GOAT_EXPERIENCE_ROLLOUT = 'tempWebEnableGoatExperienceRollout',

  // Cross Platform Flags (may affect other apps)
  // ---------------------------------------------------------------------------
  TEMP_ENABLE_STRIPE_CANADA = 'tempEnableStripeCanada',
  TEMP_WEB_ENABLE_NON_SNEAKER_BOX_CONDITION = 'tempWebEnableNonSneakerBoxCondition',
}

export const getSnakeCaseFeatureFlags = (obj) => {
  return Object.keys(obj).map((key) => snakeCase(key));
};
